import { useSelector } from 'react-redux'

export const useAccountibilitySelector = () => {

    const accountabilityResponse = useSelector((state) => state.accountability)

    const patientListResponse = accountabilityResponse.fetchPatientList
    const patientRxDetailResponse = accountabilityResponse.addPatientRxDetail
    const rxAccountabilityPdfResponse = accountabilityResponse.fetchRxAccountabilityPdf
    const todayProcessedRoutesResponse = accountabilityResponse.todayProcessedRoutes
    const todayProcessedRoutesData = todayProcessedRoutesResponse?.data?.data?.pending_routes
    const todayProcessPickedRouteResponse = todayProcessedRoutesResponse?.data?.data?.picked_route
    const todayProcessPickedRouteData = todayProcessedRoutesResponse?.data?.data?.picked_route_data
    const prepareCheckResponse = accountabilityResponse.prepareCheck
    const prepCheckPatientPrescriptionResponse = accountabilityResponse.prepCheckPatientPrescription
    const assignDinLotResponse = accountabilityResponse.assignDinLot
    const pickupLogResponse = accountabilityResponse.pickupLog
    const pickupSingleRouteResponse = accountabilityResponse.pickupSingleRoute
    const finalCheckLoadPatientsResponse = accountabilityResponse.finalCheckLoadPatients
    const finalCheckRouteListResponse = accountabilityResponse.finalCheckRouteList
    const finalCheckRouteListData = finalCheckRouteListResponse?.data?.data?.routes
    const finalCheckPatientPrescriptionResponse = accountabilityResponse.finalCheckPatientPrescription
    const todayMissedRxRouteListResponse = accountabilityResponse.todayMissedRxRouteList
    const todayMissedRxRouteListDetailsResponse = accountabilityResponse.todayMissedRxRouteListDetails
    const afterProcessPrepRouteListResponse = accountabilityResponse.afterProcessPrepRouteList
    const afterProcessPrepRouteRxDataResponse = accountabilityResponse.afterProcessPrepRouteRxData
    const deliveryDriverListResponse = accountabilityResponse.deliveryDriverList
    const prepButNotBilledResponse = accountabilityResponse.prepButNotBilled
    const flexiDeliverResponse = accountabilityResponse.flexiDeliver
    const patientPaymentCollectionListResponse = accountabilityResponse.patientPaymentCollectionList
    const copayDeliveriesResponse = accountabilityResponse.copayDeliveries
    const billedButNotPreparedResponse = accountabilityResponse.billedButNotPrepared
    const dropActiveRouteResponse = accountabilityResponse.dropActiveRoute
    const wrongPrepResponse = accountabilityResponse.wrongPrep
    const notBilledPrepWrongCountResponse = accountabilityResponse.notBilledPrepWrongCount
    const drugInformationSheetResponse = accountabilityResponse.drugInformationSheet
    const getMissedRxDataResponse = accountabilityResponse.getMissedRxData
    const printLabelsResponse = accountabilityResponse.printLabels
    const searchPharmacyRxResponse = accountabilityResponse.searchPharmacyRx
    const dailyRoutineTemplateResponse = accountabilityResponse.dailyRoutineTemplate
    const lookupDailyRoutineTemplateItemResponse = accountabilityResponse.lookupDailyRoutineTemplateItem
    const createDailyRoutineTemplateItemResponse = accountabilityResponse.createDailyRoutineTemplateItem
    const updateDailyRoutineTemplateItemResponse = accountabilityResponse.updateDailyRoutineTemplateItem
    const deleteDailyRoutineTemplateItemResponse = accountabilityResponse.deleteDailyRoutineTemplateItem
    const reorderDailyRoutineTemplateItemsResponse = accountabilityResponse.reorderDailyRoutineTemplateItems
    const dailyRoutineTodayResponse = accountabilityResponse.dailyRoutineToday
    const toggleDailyRoutineRunItemResponse = accountabilityResponse.toggleDailyRoutineRunItem
    const pharmacyAccountabilityReportResponse = accountabilityResponse.pharmacyAccountabilityReport
    const reportRouteListResponse = accountabilityResponse.reportRouteList
    const downloadReportResponse = accountabilityResponse.downloadReport
    const emergencyReportResponse = accountabilityResponse.emergencyReport
    const downloadEmergencyReportResponse = accountabilityResponse.downloadEmergencyReport
    const changeDoseResponse = accountabilityResponse.changeDose
    const forceDropRouteResponse = accountabilityResponse.forceDropRoute
    const notBilledCountResponse = accountabilityResponse.notBilledCount
    const wrongPrepCountResponse = accountabilityResponse.wrongPrepCount
    const billedButNotPreparedCountResponse = accountabilityResponse.billedButNotPreparedCount
    const missed3xCountResponse = accountabilityResponse.missed3xCount
    const missed4xCountResponse = accountabilityResponse.missed4xCount
    const muteRxResponse = accountabilityResponse.muteRx
    const downloadBulkLabelResponse = accountabilityResponse.downloadBulkLabel
    const oddBillingResponse = accountabilityResponse.oddBilling
    const patientDrugInformationSheetResponse = accountabilityResponse.patientDrugInformationSheet
    const downloadPatientDrugInformationSheetResponse = accountabilityResponse.downloadPatientDrugInformationSheet
    const emergencyTodayDataResponse = accountabilityResponse.emergencyTodayData
    const dwi_Counts = accountabilityResponse?.fetchDwiCount?.data?.data?.count
    const futureChangingDoseResponse = accountabilityResponse.futureChangingDose
    const weeklyOddBillingScheduleResponse = accountabilityResponse.weeklyOddBillingSchedule
    const prepForNewRxRouteListResponse = accountabilityResponse.prepForNewRxRouteList
    const prepForNewRxRouteDataResponse = accountabilityResponse.prepForNewRxRouteData
    const fetchOddScheduleDynamicRxResponse = accountabilityResponse.fetchOddScheduleDynamicRx
    const fetchOtherFrequencyDataResponse = accountabilityResponse.fetchOtherFrequencyData
    const fetchRxDosesNotGeneratedResponse = accountabilityResponse.fetchRxDosesNotGenerated
    const fetchDilaudidDataResponse = accountabilityResponse.fetchDilaudidData
    const fetchDilaudidSameBidResponse = accountabilityResponse.fetchDilaudidSameBid
    const fetchDilaudidDifferentBidResponse = accountabilityResponse.fetchDilaudidDifferentBid
    const fetchDilaudidOthersResponse = accountabilityResponse.fetchDilaudidOthers
    const fetchNonSafeSupplyMissedDosesResponse = accountabilityResponse.fetchNonSafeSupplyMissedDoses
    const updatePacmedTimeResponse = accountabilityResponse.updatePacmedTime
    const fetchDilaudidRxTodayPdfResponse = accountabilityResponse.fetchDilaudidRxTodayPdf
    const fetchPreviousDilaudidPdfResponse = accountabilityResponse.fetchPreviousDilaudidPdf
    const fetchDoNotBillResponse = accountabilityResponse.fetchDoNotBill
    const fetchDilaudidFaxToDoctorResponse = accountabilityResponse.fetchDilaudidFaxToDoctor
    const fetchArvRxResponse = accountabilityResponse.fetchArvRx
    const previewArvRxDataForFaxResponse = accountabilityResponse.previewArvRxDataForFax
    const fetchArvRxFaxListResponse = accountabilityResponse.fetchArvRxFaxList
    const arvRxFaxViewPdfResponse = accountabilityResponse.arvRxFaxViewPdf
    const fetchRefillsRequestResponse = accountabilityResponse.fetchRefillsRequest
    const fetchDrugFamilyListResponse = accountabilityResponse.fetchDrugFamilyList
    const generateFaxPdfResponse = accountabilityResponse.generateFaxPdf
    const fetchScheduleRxResponse = accountabilityResponse.fetchScheduleRx
    const fetchDrugFamilyListPatientResponse = accountabilityResponse.fetchDrugFamilyListPatient
    const fetchDrugFamilyListAnalyticsResponse = accountabilityResponse.fetchDrugFamilyListAnalytics
    const fetchDrugVisualIntakeMissingDinsResponse = accountabilityResponse.fetchDrugVisualIntakeMissingDins

    const fetchPatientListV1Response = accountabilityResponse.fetchPatientListV1
    const saveDrugVisualIntakeResponse = accountabilityResponse.saveDrugVisualIntake

    const fetchMissingWitnessCarryRxResponse = accountabilityResponse.missingWitnessCarryRx
    const fetchNewRxListResponse = accountabilityResponse.fetchNewRxList
    const fetchNarcoticRxByDateResponse = accountabilityResponse.fetchNarcoticRxByDate
    const fetchDrugQuantityByDateResponse = accountabilityResponse.fetchDrugQuantityByDate
    const pharmacarePatientSearchResponse = accountabilityResponse.pharmacarePatientSearch
    const pharmacareDeductibleListResponse = accountabilityResponse.pharmacareDeductibleList
    const pharmacareDeductibleHistoryResponse = accountabilityResponse.pharmacareDeductibleHistory

    return {
        accountabilityResponse,
        dwi_Counts,
        patientListResponse,
        patientRxDetailResponse,
        rxAccountabilityPdfResponse,
        todayProcessedRoutesResponse,
        todayProcessedRoutesData,
        todayProcessPickedRouteResponse,
        prepareCheckResponse,
        prepCheckPatientPrescriptionResponse,
        assignDinLotResponse,
        pickupLogResponse,
        pickupSingleRouteResponse,
        finalCheckLoadPatientsResponse,
        finalCheckRouteListResponse,
        finalCheckRouteListData,
        finalCheckPatientPrescriptionResponse,
        todayMissedRxRouteListResponse,
        todayMissedRxRouteListDetailsResponse,
        afterProcessPrepRouteListResponse,
        afterProcessPrepRouteRxDataResponse,
        deliveryDriverListResponse,
        prepButNotBilledResponse,
        flexiDeliverResponse,
        patientPaymentCollectionListResponse,
        copayDeliveriesResponse,
        billedButNotPreparedResponse,
        dropActiveRouteResponse,
        todayProcessPickedRouteData,
        wrongPrepResponse,
        notBilledPrepWrongCountResponse,
        drugInformationSheetResponse,
        getMissedRxDataResponse,
        printLabelsResponse,
        searchPharmacyRxResponse,
        dailyRoutineTemplateResponse,
        lookupDailyRoutineTemplateItemResponse,
        createDailyRoutineTemplateItemResponse,
        updateDailyRoutineTemplateItemResponse,
        deleteDailyRoutineTemplateItemResponse,
        reorderDailyRoutineTemplateItemsResponse,
        dailyRoutineTodayResponse,
        toggleDailyRoutineRunItemResponse,
        pharmacyAccountabilityReportResponse,
        reportRouteListResponse,
        downloadReportResponse,
        emergencyReportResponse,
        downloadEmergencyReportResponse,
        changeDoseResponse,
        forceDropRouteResponse,
        notBilledCountResponse,
        wrongPrepCountResponse,
        billedButNotPreparedCountResponse,
        missed3xCountResponse,
        missed4xCountResponse,
        muteRxResponse,
        downloadBulkLabelResponse,
        oddBillingResponse,
        patientDrugInformationSheetResponse,
        downloadPatientDrugInformationSheetResponse,
        emergencyTodayDataResponse,
        futureChangingDoseResponse,
        weeklyOddBillingScheduleResponse,
        prepForNewRxRouteListResponse,
        prepForNewRxRouteDataResponse,
        fetchOddScheduleDynamicRxResponse,
        fetchOtherFrequencyDataResponse,
        fetchRxDosesNotGeneratedResponse,
        fetchDilaudidDataResponse,
        fetchDilaudidSameBidResponse,
        fetchDilaudidDifferentBidResponse,
        fetchDilaudidOthersResponse,
        fetchNonSafeSupplyMissedDosesResponse,
        updatePacmedTimeResponse,
        fetchDilaudidRxTodayPdfResponse,
        fetchPreviousDilaudidPdfResponse,
        fetchDoNotBillResponse,
        fetchDilaudidFaxToDoctorResponse,
        fetchArvRxResponse,
        previewArvRxDataForFaxResponse,
        fetchArvRxFaxListResponse,
        arvRxFaxViewPdfResponse,
        fetchRefillsRequestResponse,
        fetchDrugFamilyListResponse,
        fetchDrugFamilyListPatientResponse,
        fetchDrugFamilyListAnalyticsResponse,
        fetchDrugVisualIntakeMissingDinsResponse,
        fetchScheduleRxResponse,
        fetchPatientListV1Response,
        generateFaxPdfResponse,
        saveDrugVisualIntakeResponse,
        fetchMissingWitnessCarryRxResponse,
        fetchNewRxListResponse,
        fetchNarcoticRxByDateResponse,
        fetchDrugQuantityByDateResponse,
        pharmacarePatientSearchResponse,
        pharmacareDeductibleListResponse,
        pharmacareDeductibleHistoryResponse
    }
}
